import Select, { SelectProps } from 'component/part/Select';

type UserLike = Required<{
  id: number;
}> & {
  lastName?: string;
  firstName?: string;
};

export type SelectUserProps<U extends UserLike> = Omit<SelectProps<U>, 'labelKey'>;

type SelectUser<U extends UserLike> = U & { name: string };

const SelectUser = <U extends UserLike>(props: SelectUserProps<U>) => {
  const selectUsers: SelectUser<U>[] = props.list.map(
    (user) => ({ ...user, name: `${user.lastName || ''} ${user.firstName || ''}` })
  );
  const selectUser = selectUsers.find(({ id }) => id === props.value?.id);

  return <Select
      list={selectUsers}
      labelKey='name'
      value={selectUser}
      onChange={props.onChange}
      className={props.className}
    />;
};

export default SelectUser;
